import { defaultTiers, legacyTiers } from '@/data/pricing'
import { NEW_PRICING_ENABLED } from '@/utils/featureFlags'
import type { PricingTier } from '@/types/pricing'

export interface PricingTiersResult {
  tiers: PricingTier[]
  isNewPricing: boolean
}

export function usePricingTiers(): PricingTiersResult {
  return {
    tiers: NEW_PRICING_ENABLED ? defaultTiers : legacyTiers,
    isNewPricing: NEW_PRICING_ENABLED,
  }
}
